var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinimap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231 178.333L181 160.75V61.6667L231 79.25V178.333ZM276.833 45C276.333 45 275.917 45 275.5 45L231 62.5L181 45L134 60.8333C132.25 61.4167 131 62.9167 131 64.8333V190.833C131 191.938 131.439 192.998 132.22 193.78C133.002 194.561 134.062 195 135.167 195C135.583 195 136.083 195 136.5 194.75L181 177.5L231 195L278 179.167C279.75 178.333 281 177.083 281 175.167V49.1667C281 48.0616 280.561 47.0018 279.78 46.2204C278.998 45.439 277.938 45 276.833 45Z",
    fill: "var(--card-thumbnail-fg)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimap);
export default __webpack_public_path__ + "static/media/minimap.f39ae3ce9c0c1eb409935ae878894108.svg";
export { ForwardRef as ReactComponent };